import React from 'react';
import { mockServices, mockRoutes, mockRegions, mockPlugins } from '../mockData';
import { Table, Card, Row, Col, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { Service, Route, Region, RegionTarget, Plugin } from '../mockData';

const KongDashboard: React.FC = () => {
  const serviceColumns: ColumnsType<Service> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Host',
      dataIndex: 'host',
      key: 'host',
    },
    {
      title: 'Port',
      dataIndex: 'port',
      key: 'port',
    },
    {
      title: 'Protocol',
      dataIndex: 'protocol',
      key: 'protocol',
    },
  ];

  const routeColumns: ColumnsType<Route> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Paths',
      dataIndex: 'paths',
      key: 'paths',
      render: (paths: string[]) => (
        <>
          {paths.map(path => (
            <Tag key={path} color="blue">{path}</Tag>
          ))}
        </>
      ),
    },
    {
      title: 'Service ID',
      dataIndex: ['service', 'id'],
      key: 'serviceId',
    },
  ];

  const regionColumns: ColumnsType<Region> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, record: Region) => (
        <>
          {name}
          {record.tags?.map(tag => (
            <Tag key={tag} color="blue">{tag}</Tag>
          ))}
        </>
      ),
    },
    {
      title: 'Health Status',
      dataIndex: 'health_status',
      key: 'health_status',
      render: (status: string) => (
        <Tag color={status === 'healthy' ? 'success' : 'error'}>
          {status}
        </Tag>
      ),
    },
    {
      title: 'Node Status',
      dataIndex: 'node_status',
      key: 'node_status',
      render: (status: string) => (
        <Tag color={status === 'active' ? 'success' : 'error'}>
          {status}
        </Tag>
      ),
    },
    {
      title: 'Targets Count',
      key: 'targets_count',
      render: (_, record: Region) => record.targets.length,
    },
  ];

  const pluginColumns: ColumnsType<Plugin> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Service ID',
      dataIndex: ['service', 'id'],
      key: 'serviceId',
    },
    {
      title: 'Status',
      dataIndex: 'enabled',
      key: 'enabled',
      render: (enabled: boolean) => (
        <Tag color={enabled ? 'success' : 'error'}>
          {enabled ? 'Enabled' : 'Disabled'}
        </Tag>
      ),
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card title="Services">
            <Table
              columns={serviceColumns}
              dataSource={mockServices}
              rowKey="id"
              pagination={false}
            />
          </Card>
        </Col>
        <Col span={24}>
          <Card title="Routes">
            <Table
              columns={routeColumns}
              dataSource={mockRoutes}
              rowKey="id"
              pagination={false}
            />
          </Card>
        </Col>
        <Col span={24}>
          <Card title="Regions">
            <Table
              columns={regionColumns}
              dataSource={mockRegions}
              rowKey="id"
              pagination={false}
              expandable={{
                expandedRowRender: (record: Region) => (
                  <Table
                    columns={[
                      { title: 'Target', dataIndex: 'target', key: 'target' },
                      { title: 'Weight', dataIndex: 'weight', key: 'weight' },
                      {
                        title: 'Health Status',
                        dataIndex: 'health_status',
                        key: 'health_status',
                        render: (status: string) => (
                          <Tag color={status === 'healthy' ? 'success' : 'error'}>
                            {status}
                          </Tag>
                        ),
                      },
                      {
                        title: 'Node Status',
                        dataIndex: 'node_status',
                        key: 'node_status',
                        render: (status: string) => (
                          <Tag color={status === 'active' ? 'success' : 'error'}>
                            {status}
                          </Tag>
                        ),
                      },
                    ]}
                    dataSource={record.targets}
                    pagination={false}
                    rowKey="id"
                  />
                ),
              }}
            />
          </Card>
        </Col>
        <Col span={24}>
          <Card title="Plugins">
            <Table
              columns={pluginColumns}
              dataSource={mockPlugins}
              rowKey="id"
              pagination={false}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default KongDashboard; 